import { render } from "./profilesidebar.vue?vue&type=template&id=173dd600"
import script from "./profilesidebar.vue?vue&type=script&lang=js"
export * from "./profilesidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__